import React from "react";
import styles from '../Layout.module.css'
import Logo from "./Logo";

const Header = (props) => {
  const profile = [];
  if (props && props.session) {
    const s = props.session;
    profile.push(<div className={styles.r2}>{s.name}</div>)
  }

  return <div className={styles.header}>
    <Logo/>
    <a className={styles.menuItem} href="/">Data Lake</a>
    <a className={styles.menuItem} href="/downloads">Downloads</a>
    <a className={styles.menuItem} href="/audit">Audit</a>
    <div className={styles.flex}/>
    {profile}
  </div>
}

export default Header;
